//Generated File 
export default class HelpMessageContentType{
	static readonly HTML = `HTML`;
	static readonly Markdown = `Markdown`;
	static readonly Text = `Text`;
}
